import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { ROOT } from '../../../../constants/routes'

export default function LogoutRedirect() {

    const history = useHistory()

    useEffect(() => {
        setTimeout(() => {
            history.push(ROOT)
        }, 1000)
    }, [])

    return (
        <></>
    )
}
